exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable.certificate[data-v-4f2b2f9b] {\n    border-bottom: 1px solid #ddd\n}\ntable.competencies[data-v-4f2b2f9b] {\n    border-bottom: 1px solid #ddd\n}\n", ""]);

// exports
